import { api } from './_apiInterface';
import { pointer } from 'src/app-config';
import { typeLogObj, typeLogsDoc, typeLogType, typeUser } from '@monorepo/models';

class LogServices {
    private Base = pointer.log;
    //
    Delete = async (congregation: number, log: typeLogObj) => {
        const data = await api.SendRequest(this.Base, 'DELETE', { congregation, log });
        return data;
    }
    GetAll = async (all: boolean, type: typeLogType | null, congregation: number | null) => {
        const data = await api.SendRequest<{ log: typeLogsDoc; logs: typeLogsDoc[]; }>(`${this.Base}?all=${all}&type=${type ?? ''}&congregation=${congregation ?? ''}`, 'GET');
        return data;
    }
    SaveFrontendException = async (user: typeUser, error: Error, errorInfo: React.ErrorInfo) => {
        const locationHRef = window.location.href;
        const errorCause = error.cause ?? '(sin cause)';
        const errorMessage = error.message ?? '(sin message)';
        // const errorStack = error.stack?.replace(/\n/g, " ") ?? "(sin stack)";
        const errorName = error.name ?? '(sin name)';
        const errorInfoComponentStack = errorInfo.componentStack?.replace(/\n/g, ' ') ?? '(sin componentStack)';
        const text = `Excepción no controlada frontend: '${errorName}: ${errorMessage}'; causa: ${errorCause}; stack del componente: ${errorInfoComponentStack}.`;
        console.log(locationHRef, text);
        const data = await api.SendRequest(this.Base, 'POST', { locationHRef, text, user: user.isAuth ? user : null });
        return data;
    }
}

export const logServices = new LogServices();
